import type { PayPeriodReviewWorker } from "@crewledger/shared/schemas";
import { cn } from "@/lib/utils";

const STYLES: Record<
  PayPeriodReviewWorker["status"],
  { bg: string; text: string; label: string }
> = {
  COMPLETE: { bg: "bg-green-50", text: "text-green-700", label: "Approved" },
  PENDING: { bg: "bg-blue-50", text: "text-blue-700", label: "Pending" },
  NEEDS_CORRECTION: { bg: "bg-red-50", text: "text-red-700", label: "Correction" },
  INCOMPLETE: { bg: "bg-slate-100", text: "text-slate-600", label: "Incomplete" },
  EXCEPTION: { bg: "bg-amber-50", text: "text-amber-800", label: "Exception" },
};

export function WorkerReviewStatusBadge({
  status,
  className,
}: {
  status: PayPeriodReviewWorker["status"];
  className?: string;
}) {
  const style = STYLES[status];
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide",
        style.bg,
        style.text,
        className,
      )}
    >
      {style.label}
    </span>
  );
}
